import React from 'react'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { useAppSelector } from 'hooks/reduxHooks'
import ExpandableObjectView from '../../ExpandableObjectView'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextLink from 'LuxKit/TextLink'

function ReduxStateTab() {
  // Normally it would be bad practice to return the entire state from a selector,
  // but in this case showing the entire state is the whole point of the component.
  const reduxState = useAppSelector(state => state)

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <ExpandableObjectView value={reduxState} initialExpanded />

      <MessageBanner kind="informational-primary">
        See also: <TextLink href="https://chromewebstore.google.com/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en" target="_blank" rel="noopener noreferrer">Redux DevTools</TextLink>
      </MessageBanner>
    </VerticalSpacer>
  </Pane>
}

export default ReduxStateTab
